import { DEFAULT_DISTANCE, DEFAULT_LOCATION } from "@search/store/constants";
import BaseFilter from "@search/store/filters/base/BaseFilter";
import { LocationValue } from "@search/store/types";

class LocationFilter extends BaseFilter {
  constructor(value: LocationValue) {
    super({ defaultValue: DEFAULT_LOCATION, name: "location", value });
  }

  setDistance(distance: number) {
    this._value = { ...(this._value as LocationValue), distance };

    return this.serialize();
  }

  setName(slug: string) {
    const name = slug;
    const distance = this.isSet()
      ? (this._value as LocationValue).distance
      : DEFAULT_DISTANCE;

    this._value = { name, distance };

    return this.serialize();
  }

  toParam() {
    const { name, distance } = this._value as LocationValue;
    return `${name},${distance}`;
  }
}

export default LocationFilter;
export { LocationFilter };
